<template>
  <modal
    v-model="modal.show"
    :backdrop="false"
    :dismiss-btn="false"
    class="sm modal-ban"
  >
    <span slot="title" class="modal-ban__header">
      {{ $t(`modalBan.${modal.type}.title`) }}
      <i class="icon icon-icon-fechar" @click="cancel"></i>
    </span>

    <div class="modal-ban__body">
      <p>
        {{ $t(`modalBan.${modal.type}.msg`, { number }) }}
      </p>
      <p class="link">
        {{ $t(`modalBan.${modal.type}.terms.prefix`) }}
        <a
          :href="`https://www.whatsapp.com/legal/terms-of-service?lang=${$t(
            'modalBan.termsLanguage'
          )}`"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t(`modalBan.${modal.type}.terms.link`) }}
        </a>
      </p>
    </div>

    <div class="divider"></div>

    <div slot="footer" class="modal-ban__footer">
      <div class="checkbox-container">
        <input
          type="checkbox"
          id="noVisibleModal"
          name="checkbox-modal"
          class="checkbox"
          v-model="checkedHiddenModal"
        />
        <span>{{ $t(`modalBan.${modal.type}.checkbox`) }}</span>
      </div>
      <div class="actions-container">
        <a @click="cancel">
          {{ $t(`modalBan.${modal.type}.buttons.cancel`) }}
        </a>
        <btn class="button__primary" @click="confirm">
          {{ $t(`modalBan.${modal.type}.buttons.ok`) }}
        </btn>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Storage from '@octadesk/storage'

import {
  TypeLocationEnum,
  AnalyticsEvents,
  TypeMsgModalBanEnum,
  IntegratorNames
} from '@/helpers'

export default {
  computed: {
    ...mapGetters({
      modal: 'getInfosModalBan',
      contact: 'getCurrentContact',
      proActiveWhatsAppNumbers: 'proActiveWhatsAppNumbers'
    }),
    number() {
      if (!this.contact || !this.contact.agentNumber) {
        console.error('missing agent number in contact!')
        return '+'
      }
      return this.parseNumberPrefix(this.contact.agentNumber)
    }
  },
  data() {
    return {
      checkedHiddenModal: false
    }
  },
  mounted() {
    this.handleTrackEvent(TypeLocationEnum.MODAL_OPEN)
  },
  methods: {
    ...mapActions([
      'tryCreateWhatsappChat',
      'trackEvent',
      'setCurrentContact',
      'setInfosModalBan'
    ]),
    confirm() {
      try {
        if (this.modal.location !== TypeLocationEnum.REOPEN_CONVERSATION) {
          this.tryCreateWhatsappChat(this.contact)
        }

        this.setShouldHiddenModal(this.checkedHiddenModal)

        if (this.checkedHiddenModal) {
          this.handleTrackEvent(TypeLocationEnum.MODAL_CHECKED)
        }

        this.handleTrackEvent(TypeLocationEnum.MODAL_CONFIRM)

        this.handleInfosModalBan(TypeLocationEnum.MODAL_CONFIRM)
      } catch (err) {
        console.error('Error on tryCreateWhatsappChat: ', err)
      }
    },
    cancel() {
      this.handleTrackEvent(TypeLocationEnum.MODAL_CANCEL)

      this.handleInfosModalBan(TypeLocationEnum.MODAL_CANCEL)
    },
    handleTrackEvent(action) {
      if (!action) {
        throw new Error(`missing ${AnalyticsEvents.MODAL_BAN} event action!`)
      }

      const { agentNumber, clientNumber } = this.contact

      let currentAgentNumber = this.parseNumberPrefix(agentNumber)

      const integrator = this.getCurrentIntegrator(
        currentAgentNumber,
        this.proActiveWhatsAppNumbers
      )

      this.trackEvent({
        name: AnalyticsEvents.MODAL_BAN,
        properties: [
          { name: 'origin', value: this.modal.location },
          { name: 'agentNumber', value: currentAgentNumber },
          { name: 'clientNumber', value: clientNumber },
          { name: 'action', value: action },
          { name: 'integrator', value: integrator }
        ]
      })
    },
    handleInfosModalBan(typeAction) {
      this.setCurrentContact(undefined)

      this.setInfosModalBan({
        show: false,
        type: TypeMsgModalBanEnum.DEFAULT,
        event: typeAction
      })
    },
    parseNumberPrefix(number) {
      if (typeof number === 'number') {
        return `+${number}`
      }
      return number
    },
    getCurrentIntegrator(agentNumber, proActiveWhatsAppNumbers) {
      const currentIntegratorObject = proActiveWhatsAppNumbers.find(
        ({ number }) => this.parseNumberPrefix(number) === agentNumber
      )
      if (currentIntegratorObject && currentIntegratorObject.integrator) {
        return currentIntegratorObject.integrator
      } else {
        return IntegratorNames.WhatsAppOctadeskApi
      }
    },
    setShouldHiddenModal(checkedHiddenModal = false) {
      Storage.setItem('shouldHiddenModalBan', checkedHiddenModal)
    }
  }
}
</script>

<style>
/* #### OVERRIDE ### */
.modal-content {
  border-radius: 19px;
  padding: 10px 20px;
}

.modal-body {
  padding: 0 20px;
}

.modal-footer {
  padding-bottom: 5px;
}

.modal-backdrop {
  z-index: 1040 !important;
  background-color: #000;
}
</style>

<style lang="scss" scoped>
$base-color: #0074ff;

.modal-ban {
  display: flex !important;
  align-items: center;
  font-size: 1.6rem;

  .divider {
    border: 1px solid #d7d7d7;
    margin: 20px -20px 10px -20px;
  }

  &__header {
    font-weight: 700;

    .icon {
      position: absolute;
      right: 14px;
      top: 14px;
      cursor: pointer;
    }
  }

  &__body {
    padding: 0 -15px;

    .link {
      margin: 20px 0;

      a {
        text-decoration: underline;
        color: $base-color;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;

    .checkbox-container {
      display: flex;

      .checkbox {
        margin: 0 5px 0 0;
        width: 18px;
        height: 18px;
      }
    }

    .actions-container {
      a {
        color: gray;
      }
    }

    .button {
      &__primary {
        background-color: $base-color;
        border: none;
        color: white;
        border-radius: 50px;
        margin-left: 15px;
        padding: 10px 25px;
        font-size: inherit;
        max-width: 130px;
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/shared-components/ChatModalBan.vue